export default {
  /// <summary>
  /// File tạm
  /// </summary>
  Temp: 0,
  /// <summary>
  /// Các file dữ liệu mang đi
  /// </summary>
  SystemData: 1,
  /// <summary>
  /// Script sql của đăng ký dữ liệu
  /// </summary>
  Register: 2,
  /// <summary>
  /// File đính kèm
  /// </summary>
  Attachment: 3,
  /// <summary>
  /// Script nâng cấp dữ liệu khách hàng
  /// Trong này sẽ chia các thư mục nhỏ theo từng bản build
  /// 1.0.0.1, 1.0.0.2....
  /// </summary>
  SqlUpgradeTenant: 4,
  /// <summary>
  /// Script nâng cấp dữ liệu system
  /// Trong này sẽ chia các thư mục nhỏ theo từng bản build
  /// 1.0.0.1, 1.0.0.2....
  /// </summary>
  SqlUpgradeSystem: 5,
  /// <summary>
  /// Script nâng cấp dữ liệu manage
  /// Trong này sẽ chia các thư mục nhỏ theo từng bản build
  /// 1.0.0.1, 1.0.0.2....
  /// </summary>
  SqlUpgradeManage: 6,
  /// <summary>
  /// file script nâng cấp db queue
  /// </summary>
  SqlUpgradeQueue: 7,
  /// <summary>
  /// Script được chạy để tạo mới dữ liệu
  /// </summary>
  SqlCreateDatabase: 8,
  /// <summary>
  /// Sql load dữ liệu báo cáo
  /// </summary>
  ReportSql: 9,
  /// <summary>
  /// Mẫu stimul
  /// </summary>
  StimulTemplate: 10,

  /// <summary>
  /// Các file cập nhật dư thừa
  /// </summary>
  RedundantUpdating: 11,

  /// <summary>
  /// Cập nhật MisaCodeID
  /// </summary>
  UpdateMisaCodeID: 12,
  /// <summary>
  /// Các file cập nhật dữ liệu khi chuyển danh mục
  /// </summary>
  TranferDictionaryUpdating: 13,

  /**
   * File lấy bộ thông tin truyền thông
   * NTDIEM 07/09/2023
   */
  GovementAttachment: 20
};
